/**
 * Isometrie-Helfer für das Miniatur-Office.
 *
 * Weltkoordinaten in Einheiten: x läuft nach rechts unten, y nach links unten,
 * z nach oben. `iso` rechnet sie in Pixel der Welt-Fläche (W × H) um.
 */

import PropTypes from 'prop-types'

export const U = 34
export const W = 1600
export const H = 1150
const OX = 760
const OY = 300
const C = 0.866

export const iso = (x, y, z = 0) => ({
  x: OX + (x - y) * U * C,
  y: OY + (x + y) * U * 0.5 - z * U
})

export const pts = (list) =>
  list.map((p) => `${p.x.toFixed(1)},${p.y.toFixed(1)}`).join(' ')

/**
 * CSS-Matrizen, um HTML flach auf eine Ebene der Welt zu legen.
 * Ein Pixel im HTML entspricht dabei 1/U Einheit.
 */
export const onWallA = (p) => `matrix(${C}, 0.5, 0, 1, ${p.x}, ${p.y})`
export const onFloor = (p) => `matrix(${C}, 0.5, ${-C}, 0.5, ${p.x}, ${p.y})`

/** Quader mit den drei sichtbaren Flächen: oben, vorne links (+y), vorne rechts (+x). */
export function IsoBox({ x, y, z = 0, w, d, h, top, left, right }) {
  const t = [
    iso(x, y, z + h),
    iso(x + w, y, z + h),
    iso(x + w, y + d, z + h),
    iso(x, y + d, z + h)
  ]
  const l = [
    iso(x, y + d, z + h),
    iso(x + w, y + d, z + h),
    iso(x + w, y + d, z),
    iso(x, y + d, z)
  ]
  const r = [
    iso(x + w, y, z + h),
    iso(x + w, y + d, z + h),
    iso(x + w, y + d, z),
    iso(x + w, y, z)
  ]
  return (
    <g>
      <polygon points={pts(l)} fill={left} />
      <polygon points={pts(r)} fill={right} />
      <polygon points={pts(t)} fill={top} />
    </g>
  )
}

IsoBox.propTypes = {
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired,
  z: PropTypes.number,
  w: PropTypes.number.isRequired,
  d: PropTypes.number.isRequired,
  h: PropTypes.number.isRequired,
  top: PropTypes.string.isRequired,
  left: PropTypes.string.isRequired,
  right: PropTypes.string.isRequired
}

/** Flaches Viereck auf dem Boden (Teppich, Markierung). */
export function IsoRect({ x, y, w, d, z = 0, fill }) {
  return (
    <polygon
      points={pts([
        iso(x, y, z),
        iso(x + w, y, z),
        iso(x + w, y + d, z),
        iso(x, y + d, z)
      ])}
      fill={fill}
    />
  )
}

IsoRect.propTypes = {
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired,
  w: PropTypes.number.isRequired,
  d: PropTypes.number.isRequired,
  z: PropTypes.number,
  fill: PropTypes.string.isRequired
}
